import { render, staticRenderFns } from "./GenerateNewCode.vue?vue&type=template&id=080d2852&scoped=true"
import script from "./GenerateNewCode.vue?vue&type=script&lang=js"
export * from "./GenerateNewCode.vue?vue&type=script&lang=js"
import style0 from "./GenerateNewCode.vue?vue&type=style&index=0&id=080d2852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d2852",
  null
  
)

export default component.exports